import { blobticService } from '../../Commun/services/blobticService';

export interface Customer {
    id: number;
    uid: string;
    code?: string;
    name: string;
    companyName?: string;
    email?: string;
    phone?: string;
    address?: string;
    city?: string;
    country?: string;
    postalCode?: string;
    description?: string;
    lastUpdate?: Date;
    userId?: number;
    userLib?: string;
}

interface CustomerDto {
    CUS_IDF: number;
    CUS_UIDF: string;
    CUS_CODE?: string;
    CUS_LIB: string;
    CUS_COMPANY?: string;
    CUS_EMAIL?: string;
    CUS_PHONE?: string;
    CUS_ADDRESS?: string;
    CUS_CITY?: string;
    CUS_COUNTRY?: string;
    CUS_ZIP?: string;
    CUS_DESCRIPTION?: string;
    LAST_UPDT?: string;
    USER_IDF?: number;
    USR_LIB?: string;
}

const mapDtoToModel = (dto: CustomerDto): Customer => ({
    id: dto.CUS_IDF,
    uid: dto.CUS_UIDF,
    code: dto.CUS_CODE,
    name: dto.CUS_LIB,
    companyName: dto.CUS_COMPANY,
    email: dto.CUS_EMAIL,
    phone: dto.CUS_PHONE,
    address: dto.CUS_ADDRESS,
    city: dto.CUS_CITY,
    country: dto.CUS_COUNTRY,
    postalCode: dto.CUS_ZIP,
    description: dto.CUS_DESCRIPTION,
    lastUpdate: dto.LAST_UPDT ? new Date(dto.LAST_UPDT) : undefined,
    userId: dto.USER_IDF,
    userLib: dto.USR_LIB
});

const mapModelToDto = (model: Partial<Customer>): Partial<CustomerDto> => ({
    CUS_IDF: model.id,
    CUS_UIDF: model.uid,
    CUS_CODE: model.code,
    CUS_LIB: model.name,
    CUS_COMPANY: model.companyName,
    CUS_EMAIL: model.email,
    CUS_PHONE: model.phone,
    CUS_ADDRESS: model.address,
    CUS_CITY: model.city,
    CUS_COUNTRY: model.country,
    CUS_ZIP: model.postalCode,
    CUS_DESCRIPTION: model.description
});

export const customersApi = {
    getAll: async () => {
        const response = await blobticService.executeZoomRequest({
            ZoomKey: 'Blobtic_Maker',
            Action: {
                OKey: 'Blobtic_Maker,maker_customer,Select'
            }
        });
        if (response.success && Array.isArray(response.data)) {
            return {
                data: response.data.map((item: any) => mapDtoToModel(item)),
                success: true
            };
        }
        return { data: [], success: false, message: response.message };
    },

    getById: async (id: number) => {
        const response = await blobticService.executeZoomRequest({
            ZoomKey: 'Blobtic_Maker',
            Action: {
                OKey: 'Blobtic_Maker,maker_customer,Select',
                CUS_IDF: id
            }
        });
        if (response.success && Array.isArray(response.data) && response.data.length > 0) {
            return {
                data: mapDtoToModel(response.data[0]),
                success: true
            };
        }
        return { data: null, success: false, message: response.message };
    },

    create: async (customer: Partial<Customer>) => {
        const dto = mapModelToDto(customer);
        const response = await blobticService.executeZoomRequest({
            ZoomKey: 'Blobtic_Maker',
            Action: {
                OKey: 'Blobtic_Maker,maker_customer,Insert',
                ...dto
            }
        });
        return {
            success: response.success,
            message: response.message,
            data: response.data
        };
    },

    update: async (id: number, customer: Partial<Customer>) => {
        const dto = mapModelToDto(customer);
        dto.CUS_IDF = id;
        const response = await blobticService.executeZoomRequest({
            ZoomKey: 'Blobtic_Maker',
            Action: {
                OKey: 'Blobtic_Maker,maker_customer,Update',
                ...dto
            }
        });
        return {
            success: response.success,
            message: response.message
        };
    },

    delete: async (id: number) => {
        const response = await blobticService.executeZoomRequest({
            ZoomKey: 'MAKER_ZOOM',
            Action: {
                OKey: 'Blobtic_Maker,maker_customer,Delete',
                CUS_IDF: id
            }
        });
        return {
            success: response.success,
            message: response.message
        };
    }
};
